import React from "react";
import { ArrowDownIcon, ArrowUpIcon } from "@heroicons/react/20/solid";
import classNames from "classnames";
import { useOutletContext } from "react-router-dom";
import { useCurrentUser } from "../../utils/CurrentUserContext";

const reads = Math.round(Math.random() * 5000 + 1200);
const prevReads = Math.round(reads * 0.88);
const readsFormatted = reads.toLocaleString("en-US");
const prevReadsFormatted = prevReads.toLocaleString("en-US");
const totalSpend = Math.round((Math.random() * 2 + 5) * reads);
const prevTotalSpend = Math.round(parseInt(totalSpend) * 0.9595).toLocaleString(
  "en-US"
);
// const stats = [
//   {
//     name: "Total Reads",
//     stat: readsFormatted,
//     previousStat: prevReadsFormatted,
//     change: "12%",
//     changeType: "increase",
//   },
//   {
//     name: "Avg. Read Time",
//     stat: "58.16%",
//     previousStat: "56.14%",
//     change: "2.02%",
//     changeType: "increase",
//   },
//   {
//     name: "Total Spend",
//     stat: totalSpend.toLocaleString("en-US"),
//     previousStat: prevTotalSpend,
//     change: "4.05%",
//     changeType: "decrease",
//   },
// ];

const ReportVideo = () => {
  const {user} = useCurrentUser();
  const { campaign } = useOutletContext();

  const websites = campaign.publications.map(({ website, publisher, startDate }, index) => {
    return {
      website: website.name,
      publisher: publisher.name,
      reads: (new Date(startDate).getTime() / 10000) % (10000 + index),
      avgReadTime: (new Date(startDate).getTime() / 100000) % (100 + index),
      ctr: "12.1%",
      spend: Math.floor(
        (new Date(startDate).getTime() / 10000000) % (1000 + index * 5)
      ),
    };
  });

  const { reads, spend, avgReadTime } = websites.reduce(
    (acc, { reads, avgReadTime, spend, ctr }) => ({
      reads: acc.reads + reads,
      spend: acc.spend + spend,
      avgReadTime: acc.avgReadTime + avgReadTime,
      ctr: acc.ctr + ctr,
    }),
    { reads: 0, spend: 0, avgReadTime: 0 }
  );

  const stats = [
    {
      name: "Total Views",
      stat: reads.toLocaleString("en-US"),
      previousStat: Math.floor(reads / 1.12).toLocaleString("en-US"),
      change: "12%",
      changeType: "increase",
    },
    {
      name: "VTR 25%",
      stat: "52%",
      previousStat: "44%",
      change: "20%",
      changeType: "increase",
    },
    {
      name: "VTR 100%",
      stat: "17%",
      previousStat: "18%",
      change: "4%",
      changeType: "decrease",
    },
  ];
  return (
    <div>
      <div>
        <dl className="grid grid-cols-1 divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow md:grid-cols-3 md:divide-y-0 md:divide-x">
          {stats.map((item) => (
            <div key={item.name} className="px-4 py-5 sm:p-6">
              <dt className="text-base font-normal text-gray-900">
                {item.name}
              </dt>
              <dd className="mt-1 flex items-baseline justify-between md:block lg:flex">
                <div className="flex items-baseline text-2xl font-semibold text-indigo-600">
                  {item.stat}
                  <span className="ml-2 text-sm font-medium text-gray-500">
                    last week {item.previousStat}
                  </span>
                </div>

                <div
                  className={classNames(
                    item.changeType === "increase"
                      ? "bg-green-100 text-green-800"
                      : "bg-red-100 text-red-800",
                    "inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium md:mt-2 lg:mt-0"
                  )}
                >
                  {item.changeType === "increase" ? (
                    <ArrowUpIcon
                      className="-ml-1 mr-0.5 h-5 w-5 flex-shrink-0 self-center text-green-500"
                      aria-hidden="true"
                    />
                  ) : (
                    <ArrowDownIcon
                      className="-ml-1 mr-0.5 h-5 w-5 flex-shrink-0 self-center text-red-500"
                      aria-hidden="true"
                    />
                  )}

                  <span className="sr-only">
                    {" "}
                    {item.changeType === "increase"
                      ? "Increased"
                      : "Decreased"}{" "}
                    by{" "}
                  </span>
                  {item.change}
                </div>
              </dd>
            </div>
          ))}
        </dl>
      </div>

      <div className="mt-8 flex flex-col">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      Website
                    </th>
                    <th
                      scope="col"
                      className="whitespace-nowrap px-2 py-3.5 text-center text-sm font-semibold text-gray-900"
                    >
                      Video
                    </th>
                    <th
                      scope="col"
                      className="whitespace-nowrap px-2 py-3.5 text-center text-sm font-semibold text-gray-900"
                    >
                      Views
                    </th>
                    <th
                      scope="col"
                      className="whitespace-nowrap px-2 py-3.5 text-center text-sm font-semibold text-gray-900"
                    >
                      VTR 50%
                    </th>
                    <th
                      scope="col"
                      className="whitespace-nowrap px-5 py-3.5 text-center text-sm font-semibold text-gray-900"
                    >
                      VTR 75%
                    </th>
                    <th
                      scope="col"
                      className="whitespace-nowrap px-5 py-3.5 text-center text-sm font-semibold text-gray-900"
                    >
                      VTR 100%
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {websites.map((transaction) => (
                    <tr key={transaction.id}>
                      <td className="whitespace-nowrap py-2 pl-4 pr-3 text-left text-sm text-gray-500 sm:pl-6">
                        {transaction.website}
                      </td>
                      <td className="whitespace-nowrap px-2 py-2 text-center text-sm font-medium text-gray-900">
                        {transaction.publisher}
                      </td>
                      <td className="whitespace-nowrap px-2 py-2 text-center text-sm text-gray-900">
                        {transaction.reads.toLocaleString("en-US")}
                      </td>
                      <td className="whitespace-nowrap px-2 py-2 text-center text-sm text-gray-500">
                        {transaction.avgReadTime}s
                      </td>
                      <td className="whitespace-nowrap px-5 py-2 text-center text-sm text-gray-500">
                        {transaction.ctr}
                      </td>
                      <td className="whitespace-nowrap px-5 py-2 text-center text-sm text-gray-500">
                        DKK{transaction.spend}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportVideo;
